import {
  createEmptySliceBase,
  injectDetailSlice,
  injectTableSlice,
  toReducer
} from '../sliceFactory';

const createProfessionsReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'professions' });
  const withTable = injectTableSlice({ sliceBase: sliceBase });
  const withDetail = injectDetailSlice({ sliceBase: withTable });
  return toReducer(withDetail);
};

export default createProfessionsReducer;
